import checkMarkButton from '@images/emojiis-ios/check-mark-button.svg';
import counterClockWiseArrows from '@images/emojiis-ios/counter-clock-wise-arrows.svg';
import directHit from '@images/emojiis-ios/direct-hit.svg';
import greenCircle from '@images/emojiis-ios/green-circle.svg';
import hammerAndWrench from '@images/emojiis-ios/hammer-and-wrench.svg';
import orangeCircle from '@images/emojiis-ios/orange-circle.svg';
import personShrugging from '@images/emojiis-ios/person-shrugging.svg';
import poo from '@images/emojiis-ios/poo.svg';
import prohibited from '@images/emojiis-ios/prohibited.svg';
import redCircle from '@images/emojiis-ios/red-circle.svg';
import robot from '@images/emojiis-ios/robot.svg';

export const iconsHelper: Record<string, string> = {
  'check-mark-button.svg': checkMarkButton,
  'hammer-and-wrench.svg': hammerAndWrench,
  'poo.svg': poo,
  'counter-clock-wise-arrows.svg': counterClockWiseArrows,
  'direct-hit.svg': directHit,
  'robot.svg': robot,
  'prohibited.svg': prohibited,
  'person-shrugging.svg': personShrugging,
  'green-circle.svg': greenCircle,
  'orange-circle.svg': orangeCircle,
  'red-circle.svg': redCircle,
};
